import React, { useEffect, useRef, useState, useMemo } from "react";
import Styled from "styled-components";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
  Table,
  Badge,
  Space,
  Avatar,
  Modal,
  DatePicker,
} from "antd";
import { shipmentType } from "../../../Common/constant";
import UIModal from "../../../Reusablecomponents/UIModal";
import ChatComponent from "../../../Reusablecomponents/Comment/ChatComponent";
import { ReactComponent as Indicator } from "../../../assets/images/Indicator.svg";
import { ReactComponent as Chat } from "../../../assets/images/Chat.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import { useSelector } from "react-redux";
import { CALL_API } from "../../../Common/api";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import utc from "dayjs/plugin/utc";
import { convertUTCToLocal } from "../../../utils/helper";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const Wrappercontainer = Styled.div`
  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .kpireport_select_filter {
    width: 290px !important;
    height: 34px;
  }
  p {
    padding: 10px 4px 10px 4px;
    margin: 4px 0px 4px 0px;
    font-size: 18px;
    font-weight: 400;
    color: black;
  }
  .kpialerts {
    color: rgb(228, 164, 0);
  }
  .Resolved {
    color: green;
  }
  .UnResolved {
    color: red;
  }
  .customizable_container {
    width: 30%;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgb(232, 235, 240), 5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .container_two_fordropdown {
    background-color: white;
    margin-top: 25px;
    border-radius: 12px;
    padding: 25px 0px 25px 0px;
  }
  .container_for_header {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 07px 0px;
  }
  .flilter_five {
    margin: 0px;
  }
  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .filterbtn {
    width: 45px;
    height: 42px;
    borderradius: 50%;
    border: 1px solid rgb(237, 237, 241);
    backgroundcolor: rgb(235, 247, 237);
  }
  .filterstyle {
    height: 20px;
    width: 20px;
  }
  .Iconbg {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #ebf7ed;
  }
  .text-wrap {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    line-height: 1.4;
  }
  .chat-box {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .chat-message {
    background-color: #e5efff;
    border-radius: 12px;
    padding: 10px 14px;
    max-width: 75%;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .chat-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
  }

  .chat-meta {
    font-size: 11px;
    color: #666;
    display: flex;
    justify-content: flex-start;
    gap: 6px;
  }

  .chat-sender {
    font-weight: 600;
  }

  .chat-time {
    font-style: italic;
  }
  .compact-col {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 150px;
    max-width: 180px;
    transition: max-width 0.2s ease;
  }

  .compact-col.expanded {
    justify-content: flex-start;
    max-width: 250px; /* only expand a little on hover */
  }
`;
const Styledashboard = Styled.div`
.Custom {
  display: flex;
  align-items: center;
      justify-content: flex-end; /* Pushes content to the right */
  margin-bottom: 20px;
  gap: 20px;
}
    .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }
    .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }
  .head {
  margin-bottom: 5px;
  color: #5f6d8c;
  height: 29px;
font-size: 16px;
font-weight: 400;
  }
  .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .kpialerts {
    color: rgb(228, 164, 0);
    font-size: 16px;
    font-weight: 500;
  }
  .Resolved {
    color: green;
    font-size: 16px;
    font-weight: 500;
  }
  .UnResolved {
    color: red;
    font-size: 16px;
    font-weight: 500;
  }
    .values {
    color: #363636;
    font-size: 32px;
    font-weight: 600;
}
  .customizable_container {
    width: 30%;
    height: 139px;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centers content vertically */
    text-align: center; /* Centers text horizontally */
    margin-bottom: 20px;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgb(232, 235, 240), 5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }
    
  `;
const KpiReports = () => {
  const location = useLocation();
  const navState = location.state || {};
  const [filterCount, setFilterCount] = useState(0);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterform] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [kpiChart, setKPIChart] = useState([]);
  const [kpiTable, setKPITable] = useState([]);
  // Build initial values once, before the Form renders
  const getInitialValues = () => {
    let daterange = [dayjs().startOf("month"), dayjs().endOf("month")];

    if (navState.date) {
      if (Array.isArray(navState.date)) {
        // Each element may be a dead dayjs object — re-wrap with dayjs()
        daterange = navState.date.map((d) =>
          d?.$isDayjsObject ? dayjs(d.$d) : dayjs(d),
        );
      } else {
        // Single dead dayjs object — re-wrap using its internal $d (JS Date)
        const date = navState.date?.$isDayjsObject
          ? dayjs(navState.date.$d)
          : dayjs(navState.date);
        daterange = [date, date];
      }
    }

    return {
      Name: "",
      REGNO: "",
      CustName: "",
      Shipper: "",
      shipment: "",
      duration: "current_month",
      daterange,
      FNAME: "",
      code: "",
      Status:
        navState.label === "Unresolved"
          ? "0"
          : navState.label === "Resolved"
            ? "1"
            : "",
    };
  };
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const fenceList = useSelector((state) => state?.authTracking?.fenceList);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const [duration, setDuration] = useState("current_month");
  const initialValues = getInitialValues(); // call once outside component or use useMemo
  const [selectedDate, setSelectedDate] = useState(initialValues.daterange);
  const selectedDateRef = useRef(initialValues.daterange);
  const [filterValues, setFilterValues] = useState({
    Name: "",
    REGNO: "",
    CustName: "",
    Shipper: "",
    shipment: "",
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    FNAME: "",
    code: "",
    Status: "",
  });

  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [modalType, setModalType] = useState(null); // "view" or "resolve"
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [commentsList, setCommentsList] = useState([]);
  const [Hoveredrow, setHoveredRow] = useState(null);
  const [showModal, SetshowModal] = useState(false);
  const [resolveModal, setResolveModal] = useState(false);
  const [filterTrigger, setFilterTrigger] = useState(0);

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AIKPI_RPT", "EX"),
    [reduxPermissions],
  );
  const resolveAllowed = useMemo(
    () => hasPermission("AIKPI_RPT", "BR"),
    [reduxPermissions],
  );
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const debounceTimerRef = useRef(null);

  const triggerWithDebounce = (isTextInput = false) => {
    if (isTextInput) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = setTimeout(() => {
        setFilterTrigger(prev => prev + 1);
      }, 500);
    } else {
      clearTimeout(debounceTimerRef.current); // cancel any pending debounce
      setFilterTrigger(prev => prev + 1);     // fire immediately for dropdowns/pickers
    }
  };
  // 3. Same for getKPICharts
  const getKPICharts = async (filters, dates) => {
    const f = filters ?? filterValuesRef.current;
    const d = dates ?? selectedDateRef.current;

    if (!d?.[0] || !d?.[1] || !dayjs(d[0]).isValid() || !dayjs(d[1]).isValid())
      return;

    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/kpi/get_Kpialert?MCID=${userInfo?.MCID}&startDate=${dayjs(d[0]).format("YYYY-MM-DD")}&endDate=${dayjs(d[1]).format("YYYY-MM-DD")}`,
        {
          code: f?.code ?? 0,
          FNAME: f?.FNAME ?? "",
          CustName: f?.CustName ?? "",
          Shipper : f?.Shipper ?? "",
          Name: f?.Name ?? "",
          REGNO: f?.REGNO ?? "",
          Status: f?.Status ?? "",
          ConsignId: "",
          ShipmentType: f?.shipment ?? 0,
        },
      );
      setKPIChart(data);
    } catch (error) {
      console.error("[getKPICharts] error -->", error);
    } finally {
      setLoading(false);
    }
  };
  const dateRange = filterform.getFieldValue("daterange");

  // 1. Add a ref to always have latest filterValues without stale closure
  const filterValuesRef = useRef(filterValues);
  useEffect(() => {
    filterValuesRef.current = filterValues;
  }, [filterValues]);
  useEffect(() => {
    selectedDateRef.current = selectedDate;
  }, [selectedDate]);

  // 2. Rewrite getKPITable to read from refs, not closure
  const getKPITable = async (filters, dates) => {
    const f = filters ?? filterValuesRef.current;
    const d = dates ?? selectedDateRef.current;

    if (!d?.[0] || !d?.[1]) return;

    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/kpi/get_Kpialert_Table?MCID=${userInfo?.MCID}&startDate=${dayjs(d[0]).format("YYYY-MM-DD")}&endDate=${dayjs(d[1]).format("YYYY-MM-DD")}&page=${currentPage}&PageSize=${pageSize}`,
        {
          code: f?.code ?? 0,
          FNAME: f?.FNAME ?? "",
          CustName: f?.CustName ?? "",
          Shipper: f?.Shipper ?? "",
          Name: f?.Name ?? "",
          REGNO: f?.REGNO ?? "",
          Status: f?.Status ?? "",
          ConsignId: "",
          ShipmentType: f?.shipment ?? 0,
        },
      );
      setKPITable(data?.KPIAlertTable);
      setTotal(data?.totalCount || 0);
    } catch (error) {
      console.error("[getKPITable] error -->", error);
    } finally {
      setLoading(false);
    }
  };
  const getCommentData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getcommentTab`, {
      refTab: " AIKPI",
      refId: 389114,
    });
    setCommentsList(data);
    setLoading(false);
  };
  const handleBulkResolve = async (records = []) => {
    try {
      const payload = {
        uid: userInfo?.UID,
        mcid: userInfo?.MCID,
      };
      setLoading(true);
      const { ResponseCode } = await CALL_API(
        "POST",
        "/aiReport/kpi/bulkResolve",
        payload,
      );

      if (ResponseCode === 200) {
        message.success("KPIs resolved in bulk successfully!");
        setResolveModal(false);
        getKPITable();
        getKPICharts();
      }
    } catch (error) {
      console.error("Error resolving KPI:", error);
      message.error("An error occurred while resolving the KPI.");
    } finally {
      setLoading(false);
    }
  };
  const handleResolve = async (records) => {
    try {
      if (!selectedRecord?.ID) {
        message.error("No KPI selected.");
        return;
      }
      const payload = {
        ID: selectedRecord.ID,
        MESSAGE: selectedRecord.resolutionComment || "",
        RESOLVEDBY: userInfo?.UID,
      };
      setLoading(true);

      const { data, ResponseCode } = await CALL_API(
        "POST",
        "ai/kpi/resolve",
        payload,
      );
      if (ResponseCode === 200) {
        message.success(data?.data || "KPI resolved successfully!");
        setResolveModal(false);
        getKPICharts();
        getKPITable();
      }
    } catch (error) {
      console.error("Error resolving KPI:", error);
      message.error("An error occurred while resolving the KPI.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const handleresolveclose = () => {
    setResolveModal(false);
    setSelectedRecord(null);
    setModalType(null);
  };
  const handleChatClick = (record) => {
    setModalType("view"); // show resolved chat
    setSelectedRecord(record);
    setResolveModal(true);
    getCommentData(record); // pass record or ID to fetch
  };

  const handleresolveopen = (record) => {
    setModalType("resolve"); // show textarea to resolve
    setSelectedRecord(record);
    setResolveModal(true);
    getCommentData(record); // same here
  };

  const formattedTime = (minutes) => {
    return dayjs().startOf("day").add(minutes, "minute").format("HH:mm");
  };
  const formattedDifferentTime = (totalMinutes) => {
    const absMinutes = Math.abs(totalMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;

    return (
      `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}` || "00:00"
    );
  };
  const unresolvedKPIs = kpiTable?.filter((item) => !item.RESOLVEDBY);
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle special case: status field (based on RESOLVEDBY)
      if (tableSort.field === "status") {
        const aResolved = a.RESOLVEDBY != null;
        const bResolved = b.RESOLVEDBY != null;
        const result = Number(aResolved) - Number(bResolved);
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle numeric fields
      if (
        ["MAXMINUTES", "DURATION", "MINMINUTES", "RESOLVEDBY"].includes(
          tableSort.field,
        )
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const columns1 = [
    {
      title: "Date & Time",
      dataIndex: "CRON",
      key: "CRON",
      sorter: (a, b) => (a.CRON || "").localeCompare(b.CRON || ""),
      sortOrder: tableSort.field === "CRON" ? tableSort.order : null,
      render: (_, record) => {
        return (<span>{convertUTCToLocal(record?.CRON)}</span>);
      }
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
      sortOrder: tableSort.field === "Code" ? tableSort.order : null,
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      sorter: (a, b) => (a.CustName || "").localeCompare(b.CustName || ""),
      sortOrder: tableSort.field === "CustName" ? tableSort.order : null,
    },
    {
      title: "Transporter",
      dataIndex: "SupName",
      key: "SupName",
      sorter: (a, b) => (a.SupName || "").localeCompare(b.SupName || ""),
      sortOrder: tableSort.field === "SupName" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "FName",
      key: "FName",
      sorter: (a, b) => (a.FName || "").localeCompare(b.FName || ""),
      sortOrder: tableSort.field === "FName" ? tableSort.order : null,
    },
    {
      title: "KPI Name",
      dataIndex: "NAME",
      key: "NAME",
      sorter: (a, b) => (a.NAME || "").localeCompare(b.NAME || ""),
      sortOrder: tableSort.field === "NAME" ? tableSort.order : null,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => {
        const aResolved = a.RESOLVEDBY != null;
        const bResolved = b.RESOLVEDBY != null;
        return Number(aResolved) - Number(bResolved);
      },
      sortOrder: tableSort.field === "status" ? tableSort.order : null,
      render: (_, record) => {
        const isResolved =
          record.RESOLVEDBY !== null && record.RESOLVEDBY !== undefined;
        const statusText = isResolved ? "Resolved" : "Unresolved";
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {!isResolved && <Indicator />} {statusText}
          </div>
        );
      },
    },
    {
      title: "Target Duration",
      dataIndex: "MAXMINUTES",
      key: "MAXMINUTES",
      sorter: (a, b) => (a.MAXMINUTES || 0) - (b.MAXMINUTES || 0),
      sortOrder: tableSort.field === "MAXMINUTES" ? tableSort.order : null,
      render: (MAXMINUTES) => {
        return formattedTime(MAXMINUTES);
      },
    },
    {
      title: "Actual Duration",
      dataIndex: "DURATION",
      key: "DURATION",
      sorter: (a, b) => (a.DURATION || 0) - (b.DURATION || 0),
      sortOrder: tableSort.field === "DURATION" ? tableSort.order : null,
      render: (DURATION) => {
        return formattedTime(DURATION);
      },
    },
    {
      title: "Difference",
      dataIndex: "MINMINUTES",
      key: "MINMINUTES",
      sorter: (a, b) => (a.MINMINUTES || 0) - (b.MINMINUTES || 0),
      sortOrder: tableSort.field === "MINMINUTES" ? tableSort.order : null,
      render: (text) => (
        <div style={{ textAlign: "center", lineHeight: 1.5 }}>
          <div>{formattedDifferentTime(text)}</div>
          <div style={{ fontSize: "14px", color: "#888" }}>HH:MM</div>
        </div>
      ),
    },
    {
      title: "Resolved by",
      dataIndex: "USERS",
      key: "USERS",
      sorter: (a, b) => (a.USERS || "").localeCompare(b.USERS || ""),
      sortOrder: tableSort.field === "USERS" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text || "-"}</div>,
    },
    {
      title: "Message",
      dataIndex: "MESSAGE",
      key: "MESSAGE",
      sorter: (a, b) => (a.MESSAGE || "").localeCompare(b.MESSAGE || ""),
      sortOrder: tableSort.field === "MESSAGE" ? tableSort.order : null,
      render: (text) => <div>{text || "-"}</div>,
    },
    {
      title: "#",
      dataIndex: "x",
      key: "x",
      width: 120, // optional fixed width
      render: (text, record) => {
        const isResolved =
          record.RESOLVEDBY !== null && record.RESOLVEDBY !== undefined;
        const isHovered = Hoveredrow === record.key;

        return (
          <div className={`compact-col ${isHovered ? "expanded" : ""}`}>
            {!isHovered ? (
              <span>{text || "-"}</span>
            ) : (
              <>
                <Chat
                  className="cursor-pointer"
                  onClick={() => handleChatClick(record)}
                  style={{ fontSize: 18 }}
                />
                {!isResolved && (
                  <Button
                    size="small"
                    style={{
                      cursor: resolveAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!resolveAllowed) return;
                      handleresolveopen(record);
                    }}
                    className="resolve_btn"
                  >
                    Resolve
                  </Button>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];
  //export functionality for trip time reprt tabel
  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `aiReport/kpi/get_Kpialert_Table?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&page=${currentPage}&PageSize=${total}`,
        {
          code: filterValues?.code ?? 0,
          FNAME: filterValues?.FNAME || "",
          CustName: filterValues?.CustName || "",
          Shipper: filterValues?.Shipper.toString() || "",
          Name: filterValues?.Name || "",
          REGNO: filterValues?.REGNO || "",
          Status: filterValues?.Status ?? "",
          ConsignId: "",
          ShipmentType: filterValues?.shipment ?? 0,
        },
      );

      if (data?.KPIAlertTable.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.KPIAlertTable);
        const csvData = (sortedData || []).map((item) => ({
          "Date & Time": item.CRON ? convertUTCToLocal(item.CRON) : "-",
          "KPI Name": item.NAME || "",
          "Consign Code": item.Code || "",
          Consignor: item.CustName || "-",
          Transporter: item.SupName || "-",
          Consignee: item.FName || "-",
          Status:
            item.RESOLVEDBY !== null &&
            item.RESOLVEDBY !== undefined &&
            item.RESOLVEDBY !== ""
              ? "Resolved"
              : "UnResolved",
          "Actual Duration": formattedTime(item.DURATION) || "",
          "Target Duration": formattedTime(item.MAXMINUTES) || "",
          Difference: formattedDifferentTime(item.MINMINUTES) || "",
          "Resolved On": item.RESOLVEDON
            ? moment(item.RESOLVEDON).format("Do MMM YYYY; hh:mm A")
            : "-",
          "Resolved By": item.USERS || "",
          Message: item.MESSAGE || "",
        }));
        setCSVList(csvData && csvData.length > 0 ? csvData : []);

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };

  const handlemouseenter = (key) => {
    setHoveredRow(key);
  };

  const handlemouseleave = () => {
    setHoveredRow(null);
  };
  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };
  const handleFilterChange = (field, value) => {
    const latest = { ...filterform.getFieldsValue(), [field]: value };
    filterform.setFieldsValue({ [field]: value });
    setFilterValues(latest);
    filterValuesRef.current = latest;

    if (field === "daterange" && value) {
      setSelectedDate(value);
      selectedDateRef.current = value;
    }

    // text inputs debounce, everything else fires immediately
    const isTextInput = ["Name", "code"].includes(field);
    triggerWithDebounce(isTextInput);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimerRef.current);
  }, []);

  const handleDurationChange = (value) => {
    let startDate = null;
    let endDate = null;

    switch (value) {
      case "today":
        startDate = dayjs();
        endDate = dayjs();
        break;
      case "current_month":
        startDate = dayjs().startOf("month");
        endDate = dayjs().endOf("month");
        break;
      case "last_month":
        startDate = dayjs().subtract(1, "month").startOf("month");
        endDate = dayjs().subtract(1, "month").endOf("month");
        break;
      case "current_year":
        startDate = dayjs().startOf("year");
        endDate = dayjs().endOf("year");
        break;
      default:
        break;
    }

    if (startDate && endDate) {
      filterform.setFieldsValue({
        duration: value,
        daterange: [startDate, endDate],
      });
      // Update state and trigger API
      const latest = {
        ...filterform.getFieldsValue(),
        duration: value,
        daterange: [startDate, endDate],
      };
      setFilterValues(latest);
      setSelectedDate([startDate, endDate]);
      filterValuesRef.current = latest;
      selectedDateRef.current = [startDate, endDate];
     
      setFilterTrigger(prev => prev + 1);
    }
  };

  useEffect(() => {
    const initial = getInitialValues();

    const daterange = initial.daterange;
    setSelectedDate(daterange);
    selectedDateRef.current = daterange;
    filterValuesRef.current = initial;
    setFilterValues(initial);

    getKPITable(initial, daterange);
    getKPICharts(initial, daterange);
    // eslint-disable-next-line
  }, []);

 useEffect(() => {
  if (selectedDate?.[0] && selectedDate?.[1]) {
    getKPITable();
    getKPICharts();
  }
}, [filterTrigger, currentPage, pageSize]);


  return (
    <Styledashboard>
      <Row>
        <Col xl={24} sm={24}>
          <div>
            <div className="customizable_container_forkpi">
              <div className="customizable_container">
                <p className="kpialerts">KPI Alerts</p>
                <p className="values">{kpiChart?.KPIAlert?.[0]?.Total || 0}</p>
              </div>
              <div className="customizable_container">
                <p className="Resolved">Resolved</p>
                <p className="values">
                  {kpiChart?.KPIAlert?.[0]?.Resolved || 0}
                </p>
              </div>
              <div className="customizable_container">
                <p className="UnResolved">UnResolved</p>
                <p className="values">
                  {kpiChart?.KPIAlert?.[0]?.Unresolved || 0}
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div className="header-container">
        <div className="head">{total} KPI Alerts</div>
        <div
          style={{
            display: "flex", // Use Flexbox for alignment
            alignItems: "center", // Vertically align items
            justifyContent: "flex-end", // Align items to the right
            gap: "10px", // Add spacing between the icons
          }}
        >
          <div>
            <Badge count={filterCount} onClick={() => setFilterModalOpen(true)}>
              <Avatar shape="circle" size="small" src={filtericon} />
            </Badge>
          </div>
          <Spin spinning={CSVLoader}>
            <img
              src={ExportIcon}
              alt="Upload Icon"
              style={{
                cursor: exportAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={() => {
                if (!exportAllowed) return;
                prepareCSV();
              }}
            />
          </Spin>
          <CSVLink
            data={CSVList}
            filename={"KPI Report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
          <ButtonFilled
            style={{
              cursor: resolveAllowed ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (!resolveAllowed) return;
              handleBulkResolve(unresolvedKPIs);
            }}
          >
            Resolve All
          </ButtonFilled>
        </div>
      </div>
      <br />
      <div>
        <Spin spinning={loading}>
          {kpiTable?.length > 0 && (
            <StyledTable
              dataSource={kpiTable}
              columns={columns1}
              pagination={false}
              onRow={(record, index) => ({
                onMouseEnter: () => {
                  handlemouseenter(record?.key);
                },
                onMouseLeave: () => {
                  handlemouseleave();
                },
              })}
              onChange={(pagination, filters, sorter) => {
                setTableSort({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
            />
          )}
        </Spin>
      </div>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        destroyOnClose={false}
        footer={
          <ButtonFilled
            onClick={() => {
               const initial = getInitialValues();
                    filterform.resetFields();          // ← force UI to re-render all fields
                    filterform.setFieldsValue(initial);
                    setFilterValues(initial);
                    filterValuesRef.current = initial;
                    setSelectedDate(initial.daterange);
                    selectedDateRef.current = initial.daterange;
                    setFilterCount(0);
                    setFilterModalOpen(false);
                    setFilterTrigger(prev => prev + 1); // call API with reset values
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>

        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(changed, allvalues) => {
           
          }}
          initialValues={getInitialValues()} // ← dynamic based on navState
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="KPI Name" name="Name">
                <Input placeholder="" className="rounded-pill"  onChange={(e) => handleFilterChange("Name", e.target.value)} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignee" name="FNAME">
                <Select
                  className="w-100"
                  showSearch
                  onChange={(val) => handleFilterChange("FNAME", val)}
                  optionFilterProp="children"
                  options={fenceList?.map((item) => ({
                    label: item.FName,
                    value: item.FName,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignor" name="CustName">
                <Select
                  className="w-100"
                  showSearch
                  onChange={(val) => handleFilterChange("CustName", val)}
                  optionFilterProp="children"
                  options={consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.Name,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Transporter" name="Shipper">
                <Select
                  className="w-100"
                  showSearch
                  onChange={(val) => handleFilterChange("Shipper", val)}
                  optionFilterProp="children"
                  options={transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Duration" name="duration">
                <Select onChange={handleDurationChange}>
                  {Duration?.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Date Range" name="daterange">
                <RangePicker onChange={(dates, dateStrings) => {
                    handleFilterChange("daterange", dates);
                  }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consign Code" name="code">
                <Input placeholder="" className="rounded-pill" onChange={(e) => handleFilterChange("code", e.target.value)} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Status" name="Status">
                <Select
                  showSearch
                  allowClear
                  onChange={(val) => handleFilterChange("Status", val)}
                >
                  <Option value="0">UnResolved</Option>
                  <Option value="1">Resolved</Option>
                </Select>{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Vehicle No." name="REGNO">
                <Select
                  className="w-100"
                  showSearch
                  onChange={(val) => handleFilterChange("REGNO", val)}
                  optionFilterProp="children"
                  options={AIVehicleLists?.map((item) => ({
                    label: item.FVehicleName,
                    value: item.FVehicleName,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <UIModal
        width={600}
        open={resolveModal}
        onClose={handleresolveclose}
        closeButton={false}
        header={
          <Wrappercontainer>
            <Spin spinning={loading}>
              <Row>
                <Col xl={24} sm={24}>
                  <div className="modal_container_forfiltermenu">
                    <h4 className="flilter_five">
                      {modalType === "view" ? "Comments" : "Resolving KPI"}
                    </h4>
                  </div>
                  <hr />
                </Col>

                <Col xl={24} sm={24}>
                  {modalType === "view" ? (
                    <div>
                      <ChatComponent
                        data={commentsList}
                        user={userInfo?.UID}
                        getData={getCommentData}
                        id={389114}
                        RefTab="KPI"
                        setLoading={setLoading}
                      />
                    </div>
                  ) : (
                    <>
                      <strong>Comments</strong>
                      <Input.TextArea
                        placeholder="Enter resolution comments"
                        rows={4}
                        onChange={(e) =>
                          setSelectedRecord((prev) => ({
                            ...prev,
                            resolutionComment: e.target.value,
                          }))
                        }
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Spin>
          </Wrappercontainer>
        }
        footer={
          modalType === "resolve" ? (
            <Wrappercontainer>
              <div
                key="footer"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: "15px",
                }}
              >
                <Buttontransparent
                  className="cancel_btn_forpopup_two"
                  onClick={handleresolveclose}
                >
                  Cancel
                </Buttontransparent>
                <ButtonFilled onClick={() => handleResolve()}>
                  Resolve
                </ButtonFilled>
              </div>
            </Wrappercontainer>
          ) : null
        }
      />
      <ReusablePagination
        pageSize={pageSize}
        handlePageSizeChange={handlePageSizeChange}
        currentPage={currentPage}
        total={total}
        handlePageChange={handlePageChange}
      />
    </Styledashboard>
  );
};

export default KpiReports;